module.exports = __webpack_public_path__ + "img/Cheer Megaphone06.b5277757.jpg";